var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLargeArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.398438,
    y: 4.71875,
    width: 19.7195,
    height: 19.7195,
    rx: 3,
    fill: "#6ABEA5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.898438,
    y: 1.46289,
    width: 22.4756,
    height: 22.4756,
    rx: 2.5,
    stroke: "#9CD3C3",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71351 13.5273L8.8294 14.6432L4.53777 18.9349L3.42188 17.819V20.6801H6.28296L5.16707 19.5642L9.45871 15.2725L10.5746 16.3884V13.5273H7.71351Z",
    fill: "#067554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeArea);
export default __webpack_public_path__ + "static/media/large-area.b2ee96c05acade19b0b02a557fc0b269.svg";
export { ForwardRef as ReactComponent };